import type { AuthoringEdit, MergeChoice, MergeConflict, MergeResolution } from "../documentAuthoring.types";

export const plural = (count: number, one: string, many: string) => `${count} ${count === 1 ? one : many}`;

export const countEditKinds = (applied: AuthoringEdit[]): string => {
  const changes = applied.filter(edit => edit.kind !== "comment").length;
  const comments = applied.length - changes;
  const parts: string[] = [];
  if (changes) parts.push(plural(changes, "change", "changes"));
  if (comments) parts.push(plural(comments, "comment", "comments"));
  return parts.join(", ") || "No edits";
};

/** The `resolutions` payload of a conflict resubmit; undecided blocks keep the user's text. */
export const toResolutions = (conflicts: MergeConflict[], choices: Record<string, MergeChoice>): MergeResolution[] =>
  conflicts.map(conflict => ({ block_id: conflict.block_id, choice: choices[conflict.block_id] ?? "mine" }));
